import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { ReactNode } from 'react';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, HeadlineL } from '@sorare/core/src/atoms/typography';
import { ButtonWithConfirmDialog } from '@sorare/core/src/components/form/ButtonWithConfirmDialog';

import { CartAction } from '../CartAction';

type Props = {
  children?: ReactNode;
  onClear: () => void | Promise<void>;
  title: ReactNode;
  message: ReactNode;
  cta?: string;
};

export const ClearButton = ({
  children,
  onClear,
  title,
  message,
  cta,
}: Props) => {
  return (
    <ButtonWithConfirmDialog
      onConfirm={onClear}
      size="small"
      message={
        <Vertical center gap={2}>
          <FontAwesomeIcon icon={faExclamationTriangle} size="2x" />
          <HeadlineL as="h3">{title}</HeadlineL>
          <BodyM color="var(--c-nd-600)" className="text-center">
            {message}
          </BodyM>
        </Vertical>
      }
      component={CartAction}
      cta={cta}
    >
      {children}
    </ButtonWithConfirmDialog>
  );
};
